import React, { useState, useRef } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { FiDownload as DownloadIcon } from "react-icons/fi";
import "swiper/css/swiper.css";
import { Swiper, Navigation, Pagination } from "swiper/js/swiper.esm";
import ReactIdSwiperCustom from "react-id-swiper/lib/ReactIdSwiper.custom";
import Img2 from "../../assets/images/02.jpg";
import Img3 from "../../assets/images/03.jpg";
import Img4 from "../../assets/images/04.jpg";
import Img5 from "../../assets/images/05.jpg";
import Img6 from "../../assets/images/06.jpg";
import Img7 from "../../assets/images/07.jpg";
import Img8 from "../../assets/images/08.jpg";
import Img9 from "../../assets/images/09.jpg";
import Img10 from "../../assets/images/10.jpg";

import {
  Page,
  PageContent,
  Logo,
  LogoTitle,
  LogoDesafio,
  MainContent,
  Title,
  DownloadLink,
  Paragraph,
  SignUpArea,
  SignUpAreaTitle,
  Price,
  ButtonsArea,
  SignUpButton,
  SignInButton,
  Slider,
  Arrow,
  ContainerSlide,
  Important,
  ContentImportant,
  ImportantTitle,
} from "./styles";

const images = [
  { id: 2, img: Img2 },
  { id: 3, img: Img3 },
  { id: 4, img: Img4 },
  { id: 5, img: Img5 },
  { id: 6, img: Img6 },
  { id: 7, img: Img7 },
  { id: 8, img: Img8 },
  { id: 9, img: Img9 },
  { id: 10, img: Img10 },
];

function Landing({ history }) {
  const [swiper, updateSwiper] = useState(null);
  const refSwiper = useRef(null);  function handleGoToSignUp() {
    history.push("/cadastro");
  }

  function handleGoToSignIn() {
    window.open("http://www.topusperformance.com.br/aulas/login");
  }

  const settings = {
    Swiper,
    modules: [Navigation, Pagination],
    speed: 500,
    shouldSwiperUpdate: true,
    pagination: {
      el: ".swiper-pagination",
      type: 'fraction',
      clickable: true,
      renderBullet(index, className) {
        return `<span class="${className}"></span>`;
      },
    },
  };
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  return (
    <Page>
      <PageContent>
        <Logo />
        <LogoTitle>Treinamentos Online</LogoTitle>
        <LogoDesafio />
        <MainContent>
          <Title>Você está pronto para enfrentar este desafio?</Title>

          <Paragraph>
            Cadastre-se e receba um guia completo com um passo a passo de como
            transformar seu estilo de vida adquirindo hábitos saudáveis. E você
            ainda ganha:
          </Paragraph>

          <Paragraph maxWidth={340}>
            Acesso a <span>GRUPO</span> exclusivo no Telegram;
            <br />
            Treinos <span>AO VIVO</span> online;
            <br />
            Vídeo aulas com a Prof. Livia Mietherhofer;
            <br />
            <span>RECEITAS</span> exclusivas com passo a passo;
            <br />
            Um <span>PLANNER</span> exclusivo.
          </Paragraph>

          {/* <Paragraph>
            <DownloadLink
              href="http://www.topusperformance.com.br/downloads/ebook-quebrando-maus-habitos.pdf"
              download="apresentacao.pdf">
              <DownloadIcon size={18} /> Baixe nossa apresentação e saiba mais
            </DownloadLink>
          </Paragraph>

          <Title>Importante:</Title>

          <Paragraph>
            Você deverá se organizar para tirar uma foto do seu corpo ou gravar
            um vídeo curto dos registros do seu peso e da sua altura. De acordo
            com as orientações que serão passadas quando começar o Desafio. Você
            só precisa de uma balança e uma fita métrica (pode ser a balança da
            farmácia mais próxima da sua casa).
          </Paragraph> */}
        </MainContent>
      </PageContent>
      <ImportantTitle>
        CONFIRA A APRESENTAÇÃO ABAIXO E SAIBA MAIS
        <p>Passe para o lado:</p>
      </ImportantTitle>
      <ContainerSlide>
        <ReactIdSwiperCustom  ref={refSwiper}
        getSwiper={updateSwiper}
        {...settings}>
          {images.map((image) => (
            <Slider key={image.id}>
              <img src={image.img} alt="teste" />
            </Slider>
          ))}
        </ReactIdSwiperCustom>
        <Arrow direction="left" onClick={goPrev}>
          <FiArrowLeft />
        </Arrow>
        <Arrow direction="right" onClick={goNext}>
          <FiArrowRight />
        </Arrow>
      </ContainerSlide>
      <SignUpArea>
        <SignUpAreaTitle>
          Cadastre-se por apenas:
          <Price>R$ 79,90</Price>
          <ButtonsArea>
            <SignUpButton onClick={handleGoToSignUp}>Cadastre-se</SignUpButton>
            <SignInButton onClick={handleGoToSignIn}>Entrar</SignInButton>
          </ButtonsArea>
        </SignUpAreaTitle>
      </SignUpArea>
      <Important>Importante:</Important>
      <ContentImportant maxWidth={549}>
        <p>
          Você deverá se organizar para tirar uma foto do seu corpo ou gravar um
          vídeo curto dos registros do seu peso e da sua altura. De acordo com
          as orientações que serão passadas quando começar o Desafio. Você só
          precisa de uma balança e uma fita métrica (pode ser a balança da
          farmácia mais próxima da sua casa).
        </p>
      </ContentImportant>
    </Page>
  );
}

export default Landing;
